import { Moment } from "moment";
import { BrandModel } from "../models";
import { SimpleMap } from "../utils";
import { AccountModel } from "./identity";

export interface BaseModel {
  createdAt?: Moment;
  updatedAt?: Moment;
  deletedAt?: Moment | null;
  id: string;
}

export type EditModel<T extends BaseModel> = Partial<Omit<T, "id" | "createdAt" | "updatedAt" | "deletedAt">>;

export interface ShippingDetailModel {
  full_name: string;
  mobile_no: string;
  shipping_address1: string;
  shipping_address2: string;
  shipping_city_code: string;
  shipping_country_code: string;
  shipping_postcode: string;
  shipping_state_code: string;
}

export interface LocaleModel extends BaseModel {
  accountId: string;
  code: string;
  displayName: string;
  account?: AccountModel;
}

export interface LocalisationListItem {
  id: string;
  locale: Locale;
  content: SimpleMap;
}

export interface ProductLocalization extends BaseModel {
  accountId: string;
  ownerType: string;
  ownerId: string;
  localeId: string;
  content: SimpleMap;
  account?: AccountModel;
  locale?: LocaleModel;
}

export interface AssetModel extends BaseModel {
  accountId: string | null;

  viewableType?: string | null;
  viewableId?: string | null;
  type: string | null;
  filename?: string | null;
  mimeType?: string | null;
  contentLength?: number | null;
  url: string | null;
  sourceUrl?: string | null;
  sourceKey?: string;
  host?: string;
  cacheStatus?: string | null;
}

export interface BannerModel extends BaseModel {
  accountId: string;
  name: string;
  action?: string | null;
  category?: string | null;
  sortPriority?: number | null;
  status?: string;
  siteUrl?: string | null;
  account?: AccountModel;
  brand?: BrandModel;
  image?: AssetModel;
}

export enum RewardType {
  MONTHLY = "monthly",
  WEEKLY = "weekly",
  DAILY = "daily",
  VIP = "vip",
}
export interface RewardInfo {
  balance: string;
  lastClaimedAt: Moment | null;
  currentPeriodResetDate: Moment | null;
  nextPeriodResetDate: Moment | null;
}
